import './bootstrapWebpack'; // Important that this come first, to bootstrap webpack settings
import 'owa-polyfills';
import 'owa-devtools'; // Import devtools to self-initialize if enabled
import { patchMobX } from 'owa-mobx4-adapter';

export { default as bootstrap, BootstrapOptions } from './bootstrap';
import { runAfterInitialRender } from 'owa-delayed-initialization';
import { clearQueryParams } from './clearQueryParams';

// Monkey-patch MobX to proxy stale objects to the store
patchMobX();

runAfterInitialRender(() => {
    if (window && window.location && window.history) {
        clearQueryParams(window.location, window.history);
    }
});
